import { Component } from '@angular/core';

@Component({
    selector: 'app-property-manager-landing',
    templateUrl: './property-manager-landing.component.html',
    styleUrls: ['./property-manager-landing.component.scss'],
    standalone: false
})
export class PropertyManagerLandingComponent {

}
